import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { brandingService } from "services";
import { uiActions } from "store";
import { BrandingSettingsTypes, ErrorResponse } from "types";

const useSetSupportingMessageAgentOfficeMutation = (companyId: string) => {
	const dispatch = useDispatch();

	return useMutation(
		({ settings }: { settings: BrandingSettingsTypes }) => {
			return brandingService.setSupportingMessageAgentOffice({
				companyId,
				settings: {
					supporting_message: settings?.supportingMessage,
				},
			});
		},
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useSetSupportingMessageAgentOfficeMutation;
